// src/store/modules/notifications/api.js
import axios from "axios";

const BASE = "/api/v1/notifications";

// Mirrors crm/api.js authCfg: Authorization from localStorage "auth_token"
// (already a "Bearer …" string), not relying on axios defaults after reload.
function authCfg(extra) {
  const token = localStorage.getItem("auth_token");
  return { ...(extra || {}), headers: { ...(extra && extra.headers), Authorization: token } };
}

export default {
  fetch: ({ page = 1, perPage = 20 } = {}) =>
    axios.get(BASE, authCfg({ params: { page, per_page: perPage } })).then((r) => ({
      items: r.data.data || [],
      meta: r.data.meta || {},
    })),
  markSeen: () => axios.post(`${BASE}/mark_seen`, {}, authCfg()).then((r) => r.data.meta || {}),
  markRead: (id) => axios.post(`${BASE}/${id}/read`, {}, authCfg()).then((r) => r.data.meta || {}),
  markAllRead: () => axios.post(`${BASE}/read_all`, {}, authCfg()).then((r) => r.data.meta || {}),
};
